import { keepPreviousData } from "@tanstack/react-query";

import { useFetchMutation, useFetchQuery } from "common/queries/hooks";
import { OnboardingEvent } from "common/types/onboarding";

import { useFeatures } from "client/clinics/hooks";

import { OnboardingEventCreate, OnboardingClient, IOnboardingSubscription } from "../types";
import { keys, urls } from "./constants";
import { useInvalidateOnboarding } from "./invalidate";

const noop = () => null;

// The destination basis alone can set a reason, which onboarding shows only on granular controls.
export const useUnavailableReason = (subscription: IOnboardingSubscription) =>
  useFeatures().CONTROLLED_SUBSTANCE_GRANULAR_CONTROLS ? subscription.unavailable_reason : null;

export const useOnboardingQuery = () => {
  return useFetchQuery<OnboardingClient>(keys.onboarding(), {
    fetch: { url: urls.onboarding() },
    config: { placeholderData: keepPreviousData },
  });
};

export const useOnboardingEventsMutation = ({
  onSuccess = noop,
  onError,
}: {
  onSuccess?: () => void;
  onError?: () => void;
}) => {
  const invalidateOnboarding = useInvalidateOnboarding();
  return useFetchMutation<OnboardingEventCreate, OnboardingEvent>({
    fetch: (data) => ({ method: "POST", url: urls.events(), body: data }),
    config: {
      onSuccess: () => {
        invalidateOnboarding();
        onSuccess();
      },
      onError,
    },
  });
};
